import React, { memo } from 'react'
import styled, { css } from 'styled-components'
import { HeaderBtn, HeaderImg, HeaderProps } from 'src/components/layout/Header/index'
import { Noto_body3_b12, Noto_subheading_b18 } from 'src/styles/fonts/NotoSansKrFonts'
import { EmptyContainer } from 'src/components/common/EmptyContainer'
import { ellip, layoutMaxSize, ZIndex } from 'src/styles/mixin'

const HeaderViewComponent = ({
  rightBtn,
  rightImg,
  leftImg,
  text,
  joinCertGuestLayout,
}: HeaderProps) => {
  const guest = !!joinCertGuestLayout

  const renderImages = (images: HeaderImg[]) => (
    <HeaderImgContents>
      {images.map((el: HeaderImg, index) => (
        <HeaderImgElement key={index} src={el?.src} onClick={el?.func} style={el?.style} />
      ))}
    </HeaderImgContents>
  )

  const renderButton = (btns: HeaderBtn[]) => (
    <>
      {btns.map(({ src, func }: HeaderBtn, index) => (
        <HeaderBtnContents key={index * 10} onClick={func}>
          {src}
        </HeaderBtnContents>
      ))}
    </>
  )

  return (
    <HeaderViewWrap $joinCertGuest={guest}>
      <HeaderLeftContainer $joinCertGuest={guest}>
        {!!leftImg ? renderImages(leftImg) : <EmptyContainer />}
      </HeaderLeftContainer>
      {!!text && <HeaderContents $joinCertGuest={guest}>{text}</HeaderContents>}
      <HeaderRightContainer $joinCertGuest={guest}>
        {!!rightImg ? (
          renderImages(rightImg)
        ) : !!rightBtn ? (
          renderButton(rightBtn)
        ) : (
          <EmptyContainer />
        )}
      </HeaderRightContainer>
    </HeaderViewWrap>
  )
}

export const HeaderView = memo(HeaderViewComponent)

export const HeaderViewWrap = styled.header<{ $joinCertGuest?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 50px;
  min-height: 50px !important;
  color: var(--black-90);
  background: var(--white);
  padding: 0 10px 0 0;
  ${({ $joinCertGuest }) =>
    $joinCertGuest &&
    css`
      ${layoutMaxSize};
      position: fixed;
      justify-content: center;
      padding: 0 0 0 0;
      min-width: 320px;
      z-index: ${ZIndex.TopMenu};
    `}
`
export const HeaderImgContents = styled.div`
  cursor: pointer;
  display: flex;
  width: fit-content;
`
export const HeaderImgElement = styled.img.attrs({ alt: 'icon' })`
  width: fit-content;
  height: fit-content;
`

export const HeaderContents = styled.p<{ $joinCertGuest?: boolean }>`
  text-align: center;
  ${Noto_subheading_b18};
  ${ellip('line1')};
  max-width: 80%;

  ${({ $joinCertGuest }) =>
    $joinCertGuest &&
    css`
      flex: 1;
      min-width: 0;
      max-width: none;
      margin: 0 4px;
      ${Noto_body3_b12};
      ${ellip('line2')};
      text-align: center;
      word-break: keep-all;
    `}
`

export const HeaderLeftContainer = styled.div<{ $joinCertGuest?: boolean }>`
  flex-shrink: 0;
  width: 90px;
  ${({ $joinCertGuest }) =>
    $joinCertGuest &&
    css`
      width: 0;
      position: absolute;
      left: 0;
    `}
`
export const HeaderRightContainer = styled.div<{ $joinCertGuest?: boolean }>`
  flex-shrink: 0;
  width: 80px;
  ${({ $joinCertGuest }) =>
    $joinCertGuest &&
    css`
      width: 0;
    `}
`

export const HeaderBtnContents = styled.button`
  ${Noto_body3_b12};
  display: flex;
  align-items: center;
  padding: 12px 10px;
  width: fit-content;
  height: 30px;
  border-radius: 8px;
  background-color: var(--brand-10);
  color: var(--brand-50);
`
